import { render } from "./TheCartResult.vue?vue&type=template&id=62948cd8&scoped=true"
import script from "./TheCartResult.vue?vue&type=script&lang=js"
export * from "./TheCartResult.vue?vue&type=script&lang=js"

import "./TheCartResult.vue?vue&type=style&index=0&id=62948cd8&scoped=true&lang=css"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62948cd8"]])

export default __exports__